<template>
  <div class="row">
    <div class="col-12 col-md-6">
      <form role="form">
        <div class="form-group">
          <label>Imię i nazwsko</label>
          <input
            type="text"
            class="form-control"
            v-model="stylist.name"
            name="stylist_name"
          />
          <small v-show="errors.has('stylist_name')" class="text-danger">
            Pole wymagane!
          </small>
        </div>
        <div class="form-group">
          <label>Zdjęcie</label>
          <input
            type="text"
            class="form-control"
            v-model="stylist.photo"
            name="stylist_photo"
          />
          <small v-show="errors.has('stylist_photo')" class="text-danger">
            Pole wymagane!
          </small>
        </div>
        <div class="form-group">
          <label>Opis</label>
          <textarea
            class="form-control"
            v-model="stylist.description"
            name="stylist_description"
          ></textarea>
          <small v-show="errors.has('stylist_description')" class="text-danger">
            Pole wymagane!
          </small>
        </div>
      </form>
      <div class="row">
        <div class="col-12">
          <div @click="saveChange" class="btn btn-primary">
            Zapisz
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrainingStylistsForm",
  data() {
    return {
      stylist: {
        name: ""
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.$route.params.id != undefined) {
        this.$emit("loading", true);
        let url = `/${this.$route.params.shop_name}/${this.$route.params.shop_lang}/trainings/stylists/${this.$route.params.id}`;
        this.$http
          .get(url)
          .then(resp => {
            this.stylist = resp.data;
            this.$emit("loading", false);
          })
          .catch(err => {
            this.$toastr.error(err);
            this.$emit("loading", false);
          });
      }
      this.$emit("loading", false);
    },
    saveChange() {
      this.$emit("loading", true);
      let url = `/${this.$route.params.shop_name}/${this.$route.params.shop_lang}/trainings/stylists`;

      this.$http
        .customRequest({
          method: this.$route.params.id !== undefined ? "put" : "post",
          url:
            this.$route.params.id !== undefined
              ? `${url}/${this.$route.params.id}`
              : url,
          data: this.stylist
        })
        .then(() => {
          // console.log(resp);
          this.$toastr.success("Zrobione!");
          this.$emit("loading", false);
        })
        .catch(err => {
          this.$toastr.error(err);
        });
    }
  }
};
</script>
